module.exports = __webpack_public_path__ + "static/media/Etat.37ca537d.png";